export default __webpack_public_path__ + "static/media/company_background_pic.a082018b.png";